<dialog-frame header="Message" [actions]="actions()" icon="fa-comment-exclamation" (closed)="activeModal.close($event)">
	
	<p>{{ data().message }}</p>

	@if(data().bullets?.length) {
	<div class="m-1">
		<ul>
			@for(bullet of data().bullets; track bullet){
			<li>{{ bullet }}</li>
			}
		</ul>
	</div>
	}
</dialog-frame>